import { useState, useCallback } from 'react';
import { UsersApi } from '../../clients';

export const useToggleFacilityUser = () => {
  const [state, setState] = useState({
    loading: false,
    error: null,
  });

  const enableUser = useCallback(async (facilityUserId) => {
    setState({
      loading: true,
      error: null,
    });

    try {
      const response = await UsersApi.enableFacilityUser(facilityUserId);
      setState({
        loading: false,
        error: null,
      });
      return response.data;
    } catch (error) {
      console.error('Error enabling facility user:', error);
      setState({
        loading: false,
        error: error.response?.data?.message || 'Failed to enable user',
      });
      throw error;
    }
  }, []);

  const disableUser = useCallback(async (facilityUserId) => {
    setState({
      loading: true,
      error: null,
    });

    try {
      const response = await UsersApi.disableFacilityUser(facilityUserId);
      setState({
        loading: false,
        error: null,
      });
      return response.data;
    } catch (error) {
      console.error('Error disabling facility user:', error);
      setState({
        loading: false,
        error: error.response?.data?.message || 'Failed to disable user',
      });
      throw error;
    }
  }, []);

  return {
    ...state,
    enableUser,
    disableUser,
  };
};
